// /about: the public About page (handoff About.dc.html; W4-4). The hero and
// the four principles; the story section waits for the owner's own copy
// (OD-B4). Rendered inside the public site's frame (routes/_site.tsx) and
// split into its own chunk, so it never loads the signed-in app.
import { createFileRoute } from '@tanstack/react-router';
import { AboutPage } from '@/features/site/about/AboutPage';

export const Route = createFileRoute('/_site/about')({
  component: AboutPage,
});
